import React, { useEffect, useState } from "react";
import "./blog.scss";
import SuggestedPost from "./SuggestedPost";
import { useParams } from "react-router-dom";
import { useBlog } from "../../hooks/blog/useBlog";
import Loader from "../../hooks/loader";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import CustomToast from '../../components/CustomToast';
import copy from "copy-to-clipboard";


const BlogDetail = () => {
  const { id, slug } = useParams();

  // console.log(id, slug, "id, slugid, slugid, slugs");

  const {
    // fetchBlogsById,
    fetchBlogsBySlug,
    fetchAllBlogs,
    fetchAllCategories,
    blogs,
    categories,
    loading,
  } = useBlog();
  const [post, setPost] = useState(null);
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchData = async () => {
      setLocalLoading(true);
      try {
        // Fetch categories if not already loaded
        if (!categories || categories.length === 0) {
          await fetchAllCategories();
        }

        if (id) {
          let data;
          // Check if id is numeric or a slug
          // if (!isNaN(id)) {
          //   // If id is numeric, fetch by ID
          //   data = await fetchBlogsById(id);
          // } else {
          // If id is a string (slug), fetch by slug
          const slugData = await fetchBlogsBySlug(id);
          // fetchBlogsBySlug returns an array, so we need the first item
          data = slugData && slugData.length > 0 ? slugData[0] : null;
          // }

          if (data) {
            setPost(data);
          } else {
            console.error("Blog post not found with ID/slug:", id);
          }
        } else {
          console.error(
            "No blog ID provided. Please provide a valid blog ID in the URL."
          );
        }

        // If we don't have other blogs yet, fetch them for suggested posts
        if (!blogs || blogs.length === 0) {
          await fetchAllBlogs();
        }
      } catch (error) {
        console.error("Error fetching blog details:", error);
      } finally {
        setLocalLoading(false);
      }
    };

    fetchData();
  }, [
    id,
    // fetchBlogsById,
    fetchBlogsBySlug,
    fetchAllBlogs,
    fetchAllCategories,
    blogs,
    categories,
  ]);

  console.log("Blog Details", post);

  // Function to strip HTML tags from content
  const stripHtml = (html) => {
    if (!html) return "";
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // Function to get category name by ID
  const getCategoryName = (categoryId) => {
    // if (!categories || categories.length === 0) return `Category ${categoryId}`;
    const category = categories.find((cat) => cat.id === categoryId);
    return category ? category.name : ``;
  };

  // const getShareUrl = () => `http://35.91.79.19:3000/blog/${post.slug}`;
  // Update the getShareUrl function to use slug consistently
  const getShareUrl = () => {
    if (!post || !post.slug) return window.location.href;
    return `${window.location.origin}/blogdetail/${post.slug}`;
  };

  // Update the getShareTitle function to use the rendered title
  const getShareTitle = () => {
    return post?.title?.rendered || "Check out this blog post";
  };

  // Add a function to get the share description from excerpt
  const getShareDescription = () => {
    if (!post?.excerpt?.rendered) return "";
    return stripHtml(post.excerpt.rendered).substring(0, 150) + "...";
  };

  // Add a function to get the share image
  const getShareImage = () => {
    return post?.jetpack_featured_media_url || "/assets/blog/dummymain.png";
  };

  // Update the copy to clipboard function
const copyToClipboard = () => {
  const url = getShareUrl();
  try {
    copy(url);
    // toast.success("Link copied to clipboard");
    CustomToast.show('success', 'Link copied to clipboard', '');
  } catch (err) {
    console.error("Failed to copy: ", err);
    // toast.error("Failed to copy link");
    CustomToast.show('error', 'Failed to copy link', '');
  }
};

  // Update Twitter sharing
  const shareOnTwitter = () => {
    const url = getShareUrl();
    const title = getShareTitle();
    const description = getShareDescription();
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      title + ": " + description
    )}&url=${encodeURIComponent(url)}`;
    window.open(twitterUrl, "_blank");
  };

  // Update LinkedIn sharing
  const shareOnLinkedIn = () => {
    const url = getShareUrl();
    const title = getShareTitle();
    const description = getShareDescription();
    const image = getShareImage();
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      url
    )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(
      description
    )}&image=${encodeURIComponent(image)}`;
    window.open(linkedinUrl, "_blank");
  };

  // Update Facebook sharing
  const shareOnFacebook = () => {
    const url = getShareUrl();
    const title = getShareTitle();
    const description = getShareDescription();
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}&title=${encodeURIComponent(title)}&description=${encodeURIComponent(
      description
    )}`;
    window.open(facebookUrl, "_blank");
  };

  if ((loading || localLoading) && !post) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>{post?.title?.rendered}</title>
        <meta name="description" content={stripHtml(post?.excerpt?.rendered)} />

        {/* Twitter Card data */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post?.title?.rendered} />
        <meta
          name="twitter:description"
          content={stripHtml(post?.excerpt?.rendered)}
        />
        <meta
          name="twitter:image"
          content={
            post?.jetpack_featured_media_url || "/assets/blog/dummymain.png"
          }
        />

        {/* Open Graph data */}
        <meta property="og:title" content={post?.title?.rendered} />
        <meta
          property="og:description"
          content={stripHtml(post?.excerpt?.rendered)}
        />
        <meta
          property="og:image"
          content={
            post?.jetpack_featured_media_url || "/assets/blog/dummymain.png"
          }
        />
        <meta property="og:url" content={getShareUrl()} />
        <meta property="og:type" content="article" />
      </Helmet>

      <section className="blog-detail">
        <div className="main-img">
          <img
            src={
              post?.jetpack_featured_media_url || "/assets/blog/dummymain.png"
            }
            alt={post.title.rendered}
            className="img-fluid mainimg"
          />
          <img
            src="\assets\blog\shadowlayerblog.png"
            alt="shadow"
            className="img-fluid shadowlayerblog"
          />
        </div>
        <div className="custom-container">
          <div className="upper-detail">
            <div className="inline-cate">
              {post.categories &&
                categories.length > 0 &&
                post.categories.map((categoryId, index) => (
                  <p key={index}>{getCategoryName(categoryId)}</p>
                ))}
            </div>

            <h4>{post.title.rendered}</h4>
            {/* <div className="bottom-flex">
              <div className="profile">
                <img
                  src="\assets\dummy\profile.png"
                  alt="author"
                  className="img-fluid"
                />
                <h6>Author</h6>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="6"
                viewBox="0 0 6 6"
                fill="none"
              >
                <circle cx="3" cy="3" r="3" fill="white" />
              </svg>
              <p className="date-text">{formatDate(post.date)}</p>
            </div> */}
          </div>
        </div>
      </section>
      <section className="bottom-blog-detail">
        <div className="custom-container">
          <div className="shareon">
            <h6>Share On</h6>
            {/* Social Links */}
            <div className="social-links">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  copyToClipboard();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M12.5898 11.4378C12.7035 10.6302 12.7599 9.81557 12.7587 9C12.7599 8.18443 12.7035 7.36979 12.5898 6.56218H15.7827C16.347 8.13841 16.347 9.86158 15.7827 11.4378H12.5898ZM9.00006 16.2048C8.29646 16.2048 7.57823 15.4826 7.02746 14.2238C6.77585 13.6488 6.57096 12.9933 6.41758 12.2818H11.5825C11.4292 12.993 11.2243 13.6485 10.9727 14.2238C10.4219 15.4826 9.70365 16.2048 9.00006 16.2048ZM6.26335 11.4378C6.02619 9.82126 6.02619 8.17874 6.26335 6.56218H11.7368C11.8567 7.36922 11.9162 8.1841 11.9146 9C11.9162 9.8159 11.8567 10.6308 11.7368 11.4378H6.26335ZM2.2174 11.4378C1.65312 9.86158 1.65312 8.13841 2.2174 6.56218H5.41031C5.18479 8.17957 5.18479 9.82043 5.41031 11.4378H2.2174ZM9.00006 1.79518C9.70365 1.79518 10.4219 2.51707 10.9727 3.77622C11.2243 4.3512 11.4292 5.00667 11.5825 5.71815H6.41758C6.57096 5.00695 6.77585 4.35148 7.02746 3.77622C7.57823 2.51707 8.29646 1.79518 9.00006 1.79518ZM15.4169 5.71787H12.4443C12.2754 4.882 12.0407 4.11057 11.7463 3.43822C11.508 2.89279 11.2378 2.43095 10.942 2.05889C11.9011 2.3245 12.7944 2.78704 13.5648 3.41702C14.3353 4.047 14.966 4.8306 15.4169 5.71787ZM7.05813 2.05861C6.76319 2.43095 6.49329 2.89251 6.25463 3.43765C5.96024 4.11057 5.7258 4.882 5.55666 5.7173H2.58326C3.03419 4.83014 3.66497 4.04664 4.43541 3.41672C5.20585 2.7868 6.09907 2.32427 7.05813 2.05861ZM2.58326 12.2821H5.55582C5.72468 13.118 5.9594 13.8894 6.25378 14.5618C6.49244 15.1069 6.76234 15.5685 7.05729 15.9408C6.09834 15.6751 5.20526 15.2126 4.43495 14.5827C3.66465 13.9527 3.03402 13.1693 2.58326 12.2821ZM10.942 15.9408C11.2369 15.5685 11.5071 15.1069 11.7455 14.5618C12.0399 13.8889 12.2743 13.1174 12.4435 12.2821H15.4169C14.966 13.1694 14.3353 13.9531 13.5648 14.5831C12.7944 15.2131 11.9011 15.6757 10.942 15.9414V15.9408Z"
                    fill="#013159"
                  />
                </svg>
              </a>
              {/* Twitter */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  shareOnTwitter();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M13.2494 2.36458H15.5007L10.5823 7.98597L16.3684 15.6354H11.8379L8.28952 10.9961L4.22932 15.6354H1.97668L7.23738 9.6227L1.68677 2.36458H6.33224L9.5397 6.60512L13.2494 2.36458Z"
                    fill="#013159"
                  />
                </svg>
              </a>
              {/* LinkedIn */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  shareOnLinkedIn();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_3471_178)">
                    <path
                      d="M17.1626 17.1667L17.1667 17.166V11.1757C17.1667 8.24526 16.5358 5.98785 13.1099 5.98785C11.463 5.98785 10.3577 6.89163 9.90653 7.74845H9.85889V6.26144H6.6106V17.166H9.99296V11.7665C9.99296 10.3448 10.2625 8.97005 12.0231 8.97005C13.7578 8.97005 13.7837 10.5925 13.7837 11.8576V17.1667H17.1626Z"
                      fill="#013159"
                    />
                    <path
                      d="M1.10291 6.26212H4.48935V17.1667H1.10291V6.26212Z"
                      fill="#013159"
                    />
                    <path
                      d="M2.79474 0.833328C1.71197 0.833328 0.833374 1.71193 0.833374 2.79469C0.833374 3.87745 1.71197 4.77442 2.79474 4.77442C3.8775 4.77442 4.7561 3.87745 4.7561 2.79469C4.75542 1.71193 3.87682 0.833328 2.79474 0.833328Z"
                      fill="#013159"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3471_178">
                      <rect
                        width="16.3333"
                        height="16.3333"
                        fill="white"
                        transform="translate(0.833374 0.833328)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              {/* Facebook */}
              {/* Facebook */}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  shareOnFacebook();
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <g clipPath="url(#clip0_3471_183)">
                    <path
                      d="M10.2649 17.1667V9.71681H12.7645L13.1395 6.8126H10.2649V4.95869C10.2649 4.11812 10.4974 3.54529 11.7041 3.54529L13.2407 3.54465V0.947033C12.9749 0.9125 12.0628 0.833328 11.0011 0.833328C8.7842 0.833328 7.26646 2.18652 7.26646 4.67106V6.8126H4.75928V9.71681H7.26646V17.1667H10.2649Z"
                      fill="#013159"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3471_183">
                      <rect
                        width="16.3333"
                        height="16.3333"
                        fill="white"
                        transform="translate(0.833374 0.833328)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>

          {/* Render the content safely using dangerouslySetInnerHTML */}
          <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
        </div>
      </section>
      <div className="custom-container">
        {blogs && blogs.length > 0 && (
          <SuggestedPost
            currentPostId={post.id}
            allBlogs={blogs}
            categories={categories}
          />
        )}
      </div>
    </>
  );
};

export default BlogDetail;
